__turbopack_context__.v({
  "active": "header-module__CTCUoq__active",
  "appear0": "header-module__CTCUoq__appear0",
  "appear1": "header-module__CTCUoq__appear1",
  "appear2": "header-module__CTCUoq__appear2",
  "appear3": "header-module__CTCUoq__appear3",
  "appear4": "header-module__CTCUoq__appear4",
  "appear5": "header-module__CTCUoq__appear5",
  "glyphs": "header-module__CTCUoq__glyphs",
  "header": "header-module__CTCUoq__header",
  "hidden": "header-module__CTCUoq__hidden",
  "left": "header-module__CTCUoq__left",
  "logo": "header-module__CTCUoq__logo",
  "nav": "header-module__CTCUoq__nav",
  "right": "header-module__CTCUoq__right",
  "wrapper": "header-module__CTCUoq__wrapper",
});
